import {
  ALL_TEXT,
  ALLERGENS_TEXT,
  CANCELLED_TEXT,
  CARRIERS_TEXT,
  COST_PERCENTAGE_TEXT,
  COST_TEXT,
  DRAFT_TEXT,
  GENERAL_TEXT,
  HEAVY_METALS_TEXT,
  ING_COST_CONTRIBUTION_TEXT,
  METRICS_TEXT,
  NUTRIENTS_TEXT,
  NUTRIENTS_WEIGHTS_TEXT,
  PACKAGE_ESTIMATOR_TEXT,
  PAID_TEXT,
  PENDING_TEXT,
  SHOW_ALL_TEXT,
  SUB_COMPONENT_TEXT,
  UNABLE_TO_COLLECT,
  WEIGHT_TEXT,
  WEIGHTS_PERCENTAGE_TEXT,
} from 'constants/index';
import { FormulaStatus, InvoiceStatus, SupplierStatus, UserStatus, UserType } from 'generated/graphql';
import { formatValue } from 'lib/helper';

export enum IngredientTabsEnum {
  GENERAL = 'general',
  ALLERGENS = 'allergens',
  NUTRIENTS = 'nutrients',
  HEAVY_METALS = 'heavy_metals',
  CARRIERS = 'carriers',
  SUB_COMPONENT = 'sub_component',
}

export enum SyrupBaseIngredientTabsEnum {
  GENERAL = 'general',
  NUTRIENTS = 'nutrients',
  HEAVY_METALS = 'heavy_metals',
}

export enum FormulaTabEnum {
  COST = 'cost',
  WEIGHTS = 'weights',
  COST_PERCENTAGE = 'cost_percentage',
  WEIGHTS_PERCENTAGE = 'weight_percentage',
  ING_COST_CONTRIBUTION = 'ing_cost_contribution',
  NUTRIENTS_WEIGHTS = 'nutrients_weights',
}

export enum FormulaMetricsEnum {
  COST = 'cost',
  PACKAGE = 'weights',
}

export enum PlanTabsEnum {
  PLANS = 'plans',
  CHECKOUT = 'checkout',
}

export const FORMULA_COST_TABS = [
  { name: PACKAGE_ESTIMATOR_TEXT, value: FormulaMetricsEnum.PACKAGE },
  { name: METRICS_TEXT, value: FormulaMetricsEnum.COST },
];

export const FORMULA_INFO_TABS = [
  { name: COST_TEXT, value: FormulaTabEnum.COST },
  { name: WEIGHT_TEXT, value: FormulaTabEnum.WEIGHTS },
  { name: COST_PERCENTAGE_TEXT, value: FormulaTabEnum.COST_PERCENTAGE },
  { name: WEIGHTS_PERCENTAGE_TEXT, value: FormulaTabEnum.WEIGHTS_PERCENTAGE },
  { name: ING_COST_CONTRIBUTION_TEXT, value: FormulaTabEnum.ING_COST_CONTRIBUTION },
  { name: NUTRIENTS_WEIGHTS_TEXT, value: FormulaTabEnum.NUTRIENTS_WEIGHTS },
];

export const INGREDIENT_TABS = [
  { name: GENERAL_TEXT, value: IngredientTabsEnum.GENERAL },
  { name: NUTRIENTS_TEXT, value: IngredientTabsEnum.NUTRIENTS },
  { name: HEAVY_METALS_TEXT, value: IngredientTabsEnum.HEAVY_METALS },
  { name: ALLERGENS_TEXT, value: IngredientTabsEnum.ALLERGENS },
  { name: CARRIERS_TEXT, value: IngredientTabsEnum.CARRIERS },
  { name: SUB_COMPONENT_TEXT, value: IngredientTabsEnum.SUB_COMPONENT },
];

export const SYRUP_BASE_INGREDIENT_TABS = [
  { name: GENERAL_TEXT, value: SyrupBaseIngredientTabsEnum.GENERAL },
  { name: NUTRIENTS_TEXT, value: SyrupBaseIngredientTabsEnum.NUTRIENTS },
  { name: HEAVY_METALS_TEXT, value: SyrupBaseIngredientTabsEnum.HEAVY_METALS },
];

export const STAFF_TABS = [
  { name: formatValue(UserStatus.Active), value: UserStatus.Active },
  { name: formatValue(UserStatus.Inactive), value: UserStatus.Inactive },
  { name: ALL_TEXT, value: 'all' },
];

export const SUPPLIER_TABS = [
  { name: formatValue(SupplierStatus.Active), value: SupplierStatus.Active },
  { name: formatValue(SupplierStatus.Inactive), value: SupplierStatus.Inactive },
  { name: ALL_TEXT, value: 'all' },
];

export const USER_TABS = [
  { name: formatValue(UserStatus.Active), value: UserStatus.Active },
  { name: formatValue(UserStatus.Inactive), value: UserStatus.Inactive },
  { name: ALL_TEXT, value: 'all' },
];

export const USER_REPORT_TABS = [
  { name: ALL_TEXT, value: 'all' },
  { name: formatValue(UserType.Admin), value: UserType.Admin },
  { name: formatValue(UserType.Staff), value: UserType.Staff },
];

export const FORMULA_TABS = [
  { name: 'Active', value: FormulaStatus.Active },
  { name: 'Inactive', value: FormulaStatus.Inactive },
  { name: 'Draft', value: FormulaStatus.Draft },
  { name: ALL_TEXT, value: 'all' },
];

export const INVOICE_TABS = [
  { name: PAID_TEXT, value: InvoiceStatus.Paid },
  { name: PENDING_TEXT, value: InvoiceStatus.Open },
  { name: CANCELLED_TEXT, value: InvoiceStatus.Void },
  { name: UNABLE_TO_COLLECT, value: InvoiceStatus.Uncollectible },
  { name: DRAFT_TEXT, value: InvoiceStatus.Draft },
  { name: SHOW_ALL_TEXT, value: 'all' },
];

// Define a common enum for Active and Inactive states
export enum TabEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  All = 'ALL',
}

export enum CheckoutTabs {
  NEW = 'new',
  EXISTING = 'existing',
}

// Define a common array for Active and Inactive states
export const TABS = [
  { name: 'Active', value: TabEnum.Active },
  { name: 'Inactive', value: TabEnum.Inactive },
  { name: ALL_TEXT, value: TabEnum.All },
];
